<div class="dl-icon" aria-hidden="true">
  <div class="gl">
    @for (layer of glitchLayers; track layer) {
      <svg [attr.class]="'gl-layer ' + layer" viewBox="-6 -6 154 137">
        <path class="gl-face" [attr.d]="facePath" />
        <path class="gl-eyes" [attr.d]="eyesPath" />
      </svg>
    }
    <svg class="gl-layer gl-noise" viewBox="-6 -6 154 137">
      <defs>
        <clipPath [attr.id]="clipId"><path [attr.d]="facePath" /></clipPath>
        <pattern [attr.id]="patternId" width="6" height="3" patternUnits="userSpaceOnUse">
          <rect class="gl-panel" width="6" height="1.2" opacity=".55" />
          <rect class="gl-panel" x="3" width="1.5" height="3" opacity=".35" />
        </pattern>
      </defs>
      <rect
        x="-6"
        y="-6"
        width="154"
        height="137"
        [attr.fill]="'url(#' + patternId + ')'"
        [attr.clip-path]="'url(#' + clipId + ')'" />
    </svg>
    <div class="gl-scan"></div>
  </div>
</div>
<h1 class="dl-title" [id]="headingId()">{{ translate('contentUnavailableTitle') }}</h1>
<p class="dl-text">{{ translate('contentUnavailableMessage') }}</p>
<div class="dl-actions">
  <button type="button" class="dl-btn dl-btn-primary" (click)="goHome.emit()">
    {{ translate('contentUnavailableGoHome') }}
  </button>
  <button type="button" class="dl-btn dl-btn-secondary" (click)="goBack.emit()">
    {{ translate('contentUnavailableGoBack') }}
  </button>
</div>
